export function PageLoadingSkeleton({ label = 'Loading page', variant = 'standard' }) {
  const cardCount = variant === 'compact' ? 2 : 3;

  return (
    <section className="page-shell page-loading-skeleton" aria-label={label}>
      <div className="page-loading-head" aria-hidden="true">
        <span className="skeleton-line skeleton-kicker" />
        <span className="skeleton-line skeleton-section-heading" />
        <span className="skeleton-line skeleton-copy" />
      </div>

      <div className="page-loading-grid" aria-hidden="true">
        <div className="detail-panel page-loading-panel">
          <span className="skeleton-line skeleton-card-title" />
          <span className="skeleton-line" />
          <span className="skeleton-line skeleton-short" />
          <span className="skeleton-block skeleton-home-search" />
        </div>

        <div className="page-loading-stack">
          {Array.from({ length: cardCount }, (_, index) => (
            <div key={index} className="detail-panel page-loading-panel">
              <span className="skeleton-line skeleton-card-title" />
              <span className="skeleton-line" />
              <span className="skeleton-line skeleton-copy" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
